// extracted by mini-css-extract-plugin
export var columnItem = "_cl-3";
export var columnItemDraggable = "_cl-4";
export var dragHandle = "_cl-0";
export var dragHandleHovered = "_cl-1";
export var dropdown = "_cl-5";
export var dropdownContent = "_cl-7";
export var dropdownInner = "_cl-6";
export var filterDropdownHeader = "_cl-8";
export var icon = "_cl-2";
export var sectionDivider = "_cl-9";